const DownloadCircle01Icon = /*#__PURE__*/ [
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 12.5C16 12.5 13.054 16.4999 12 16.4999C10.9459 16.4999 8 12.4999 8 12.4999M12 15.9999V7.49994", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { DownloadCircle01Icon as default };
//# sourceMappingURL=DownloadCircle01Icon.js.map
